import client from "../client"

export type TApiParameter = {
  id: number;
  shortname: string;
  name: string;
  description: string;
}

const list = (): Promise<Array<TApiParameter>> => client.get('/param/').then(response => response.data);

export {
  list
}
